export function getAgeSegment(age: number): string {
  if (age < 0) {
    throw new Error('Invalid age')
  } else if (age < 12) {
    return '0 - 12'
  } else if (age < 18) {
    return '12 - 18'
  } else if (age < 25) {
    return '18 - 25'
  } else if (age < 35) {
    return '25 - 35'
  } else if (age < 45) {
    return '35 - 45'
  } else if (age < 55) {
    return '45 - 55'
  } else if (age < 65) {
    return '55 - 65'
  } else if (age < 75) {
    return '65 - 75'
  } else if (age < 85) {
    return '75 - 85'
  } else {
    return '85+'
  }
}
